<template>
  <div id="app">
    <header v-if="flag">
      <head-top></head-top>
    </header>
    <el-header v-if="flagphone" height="46px">
      <phoneHeadTop></phoneHeadTop>
    </el-header>
    <router-view />
     <el-footer style="height:auto;padding:0">
      <Footer></Footer>
    </el-footer>
    <el-backtop></el-backtop>
  </div>
</template>
<script>
import HeadTop from '@/components/HeadTop'
import phoneHeadTop from '@/views/PhoneHeadTop'
import Footer from '@/views/Footer'
import {initWebSocket} from './socket'
export default {
  name: 'App',
  data () {
    return {
      flag: undefined,
      flagphone: undefined
    }
  },
  created () {
    if (this.$store.state.user) {
      initWebSocket()
    }
  },
  mounted () {
    if (this._isMobile()) {
      this.flag = false
      this.flagphone = true
    } else {
      this.flag = true
      this.flagphone = false
    }
  },
  components: {
    HeadTop: HeadTop,
    phoneHeadTop: phoneHeadTop,
    Footer: Footer
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  }
}
</script>
<style scope>
@import "../static/css/style.css";
.copyright {
  background: #000000;
  width: 100%;
  line-height: 50px;
}
[v-cloak] {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue